import React from 'react'
import { COLORS } from '../../styles/colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const CircuitArrow = (props) => {
  return (
    <div
      onMouseDown={props.onMouseDown}
      style={{
        display: 'flex',
        height: 40,
        alignItems: 'center',
        background: 'transparent',
        justifyContent: 'space-between',
        width:194
      }}>
      <div
        style={{
          display: 'flex',
          height: 40,
          alignItems: 'center',
          background: COLORS.greyThree,
          justifyContent: 'space-between',
          paddingLeft: 10,
          color: COLORS.white,
          borderTopLeftRadius: 5,
          borderBottomLeftRadius: 5,
          width:170
        }}>
        <div>
          <FontAwesomeIcon icon="grip-vertical"
            style={{marginRight: 5, color: COLORS.white}}/>
        </div>
        <div>
          ADD CIRCUIT ROUND
        </div>
      </div>


      <div style={{
        borderTop: '20px solid transparent',
        borderBottom: '20px solid transparent',
        borderLeft: '30px solid '+COLORS.greyThree
      }} />
    </div>
  )
}

export default CircuitArrow



// WEBPACK FOOTER //
// ./src/components/workouts/CircuitArrow.js